module.exports = __webpack_public_path__ + "static/img/alarmsummary.9c32f7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarmsummary.png
// module id = 5rXg
// module chunks = 1